import type { GetOrdersOptions, TakeawayOrderFilters } from '../../../api/orders';

export const ordersKeys = {
  all: ['orders'] as const,
  list: (options?: GetOrdersOptions) =>
    options ? (['orders', options] as const) : (['orders'] as const),
  detail: (id?: string | null) => ['activeOrder', id] as const,
  byId: (id?: string | null) => ['orders', 'detail', id] as const,
  table: (tableId?: string | null) => ['ordersByTable', tableId] as const,
  takeaway: {
    listBase: ['takeaway', 'list'] as const,
    list: (filters?: TakeawayOrderFilters) =>
      (['takeaway', 'list', filters ?? {}] as const),
    detail: (id?: string | null) => ['takeaway', 'detail', id] as const,
  },
} as const;

export type OrdersKeys = typeof ordersKeys;
